export const mediaList = [
  {
    id: "haohao-shiguang",
    title: "好好的时光",
    type: "teleplay",
    year: 2024,
    region: "中国大陆",
    genres: ["都市", "情感", "家庭"],
    actors: ["林知夏", "陆延舟", "苏晚晴", "周砚书"],
    director: "顾承安",
    description:
      "《好好的时光》讲述小城女孩林知夏只身闯荡大城市，在职场与情感的双重浪潮里跌跌撞撞，却始终守住内心那点温柔与倔强。从弄堂口的老槐树到摩天楼下的深夜加班，她与挚友、爱人一次次错过又一次次重逢，用最平凡的坚持，把支离破碎的日子过成了好好的时光。全剧以细腻笔触描摹普通人如何在时代洪流中，认真地爱、认真地活。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20urban%20drama%20poster%2C%20young%20woman%20with%20soft%20warm%20backlight%20standing%20on%20a%20city%20rooftop%20at%20dusk%2C%20orange%20amber%20tones%20with%20deep%20charcoal%20background%2C%20minimal%20elegant%20composition%2C%20artistic%20moody%20atmosphere%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=juzi-cover-haohao&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20young%20Chinese%20woman%20gazing%20over%20a%20city%20skyline%20at%20golden%20sunset%2C%20warm%20orange%20amber%20glow%20against%20deep%20charcoal%20sky%2C%20soft%20film%20grain%20and%20bokeh%20lights%2C%20atmospheric%20moody%20artistic%20composition%2C%20high%20detail%20cinematic%20photography&width=1920&height=1080&seq=juzi-banner-haohao&orientation=landscape",
    episodeCount: 40,
    updateStatus: "全集完结",
    rating: 9.2,
    views: 328400000,
    tags: ["热播", "口碑剧", "完结"],
    seasons: [{ name: "第一季", count: 40 }],
  },
  {
    id: "long-night-galaxy",
    title: "长夜星河",
    type: "teleplay",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "权谋", "爱情"],
    actors: ["沈慕白", "姜雨薇", "萧景程"],
    director: "裴清和",
    description:
      "乱世之中，将门之女姜雨薇被迫卷入朝堂暗涌，与冷面谋士沈慕白从彼此试探到生死相托。长夜漫漫，他们以一盏孤灯照亮彼此的星河，在权谋与情义之间，写下了一段荡气回肠的传奇。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20costume%20drama%20poster%2C%20elegant%20figure%20in%20flowing%20robe%20under%20a%20starry%20night%20sky%2C%20deep%20indigo%20charcoal%20background%20with%20warm%20amber%20lanterns%2C%20mysterious%20romantic%20mood%2C%20artistic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-galaxy&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20an%20ancient%20Chinese%20palace%20under%20a%20vast%20starry%20night%20sky%20with%20warm%20amber%20lantern%20glow%20and%20mist%2C%20deep%20charcoal%20and%20indigo%20tones%2C%20epic%20mysterious%20atmosphere%2C%20artistic%20cinematic%20composition%2C%20high%20detail&width=1920&height=1080&seq=juzi-banner-galaxy&orientation=landscape",
    episodeCount: 36,
    updateStatus: "更新至36集",
    rating: 8.7,
    views: 182300000,
    tags: ["古装", "热播"],
    seasons: [{ name: "第一季", count: 36 }],
  },
  {
    id: "spring-passing",
    title: "春日过境",
    type: "teleplay",
    year: 2023,
    region: "中国大陆",
    genres: ["爱情", "青春", "治愈"],
    actors: ["温言", "陈屿", "许棠"],
    director: "程一诺",
    description:
      "小城咖啡馆的老板娘温言，遇见了带着一箱旧照片归乡的摄影师陈屿。两个曾在各自人生里受过伤的人，在一个又一个春天的午后，慢慢拼凑出关于爱与被爱的答案。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20romance%20drama%20poster%2C%20gentle%20spring%20sunlight%20through%20cafe%20window%2C%20soft%20orange%20and%20cream%20tones%20over%20charcoal%20shadows%2C%20delicate%20healing%20mood%2C%20artistic%20minimal%20composition%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=juzi-cover-spring&orientation=portrait",
    episodeCount: 30,
    updateStatus: "全集完结",
    rating: 8.5,
    views: 96000000,
    tags: ["治愈", "完结"],
    seasons: [{ name: "第一季", count: 30 }],
  },
  {
    id: "shanghai-years",
    title: "山海拾光",
    type: "teleplay",
    year: 2023,
    region: "中国大陆",
    genres: ["年代", "励志", "剧情"],
    actors: ["罗启明", "叶淑贞", "赵大山"],
    director: "闻天野",
    description:
      "上世纪八十年代，一群年轻人怀揣梦想南下创业。他们从一间漏雨的仓库起步，历经风雨，最终把小生意做成了大事业。这是一代人的奋斗史，也是一段关于山海与光阴的深情回望。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20retro%20Chinese%20period%20drama%20poster%2C%20vintage%201980s%20style%20figures%20by%20the%20sea%20at%20dusk%2C%20amber%20and%20sepia%20tones%20with%20deep%20charcoal%20shadows%2C%20nostalgic%20warm%20atmosphere%2C%20artistic%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-shanhai&orientation=portrait",
    episodeCount: 42,
    updateStatus: "全集完结",
    rating: 8.9,
    views: 143700000,
    tags: ["年代", "口碑剧"],
    seasons: [{ name: "第一季", count: 42 }],
  },
  {
    id: "city-ferryman",
    title: "都市摆渡人",
    type: "teleplay",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "剧情"],
    actors: ["韩司南", "何以宁", "马奔腾"],
    director: "陆则言",
    description:
      "深夜出租车司机韩司南，载过形形色色的乘客。每段短短的车程背后，都藏着一个人生的秘密。直到有一天，他遇见了那个改变自己命运的乘客，都市的夜幕之下，真相缓缓浮出水面。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20noir%20thriller%20drama%20poster%2C%20lonely%20taxi%20in%20rainy%20night%20city%20with%20neon%20amber%20reflections%2C%20deep%20charcoal%20and%20black%20tones%2C%20suspenseful%20moody%20atmosphere%2C%20artistic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-ferryman&orientation=portrait",
    episodeCount: 24,
    updateStatus: "更新至24集",
    rating: 8.4,
    views: 88700000,
    tags: ["悬疑", "热播"],
    seasons: [{ name: "第一季", count: 24 }],
  },
  {
    id: "youth-chronicle",
    title: "我的青春纪事",
    type: "teleplay",
    year: 2022,
    region: "中国大陆",
    genres: ["青春", "校园", "成长"],
    actors: ["夏一鸣", "林小满", "高子谦"],
    director: "许知远",
    description:
      "高中三年，是夏一鸣与伙伴们最兵荒马乱的时光。暗恋、考试、离别和重逢，都被写进了那本破旧的青春纪事里。多年后再翻开，才发现那段岁月，原来如此滚烫。",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20youth%20campus%20drama%20poster%2C%20students%20cycling%20under%20golden%20afternoon%20sunlight%2C%20warm%20amber%20tones%20with%20soft%20charcoal%20background%2C%20bittersweet%20nostalgic%20mood%2C%20artistic%20composition%2C%20high%20detail%20photography&width=600&height=900&seq=juzi-cover-youth&orientation=portrait",
    episodeCount: 32,
    updateStatus: "全集完结",
    rating: 8.3,
    views: 76500000,
    tags: ["青春", "完结"],
    seasons: [{ name: "第一季", count: 32 }],
  },
  {
    id: "mountain-return",
    title: "山河归途",
    type: "teleplay",
    year: 2024,
    region: "中国大陆",
    genres: ["历史", "战争", "剧情"],
    actors: ["傅长庚", "柳无咎", "白露"],
    director: "岳山河",
    description:
      "烽火连天的岁月里，一群年轻人为守护家园踏上漫漫归途。他们在山河之间辗转，在生死之间抉择，用热血与信念，为后人铺就了一条通向光明的路。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20historical%20war%20drama%20poster%2C%20silhouettes%20of%20figures%20marching%20across%20mountain%20ridge%20at%20sunrise%2C%20warm%20amber%20light%20against%20deep%20charcoal%20sky%2C%20heroic%20solemn%20mood%2C%20artistic%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-mountain&orientation=portrait",
    episodeCount: 38,
    updateStatus: "全集完结",
    rating: 8.8,
    views: 112900000,
    tags: ["历史", "口碑剧"],
    seasons: [{ name: "第一季", count: 38 }],
  },
  {
    id: "midnight-train",
    title: "午夜列车",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "惊悚"],
    actors: ["顾青山", "苏黎", "程默"],
    director: "方致远",
    description:
      "一列驶向远方的午夜列车，八名素不相识的乘客，一场突如其来的命案。当列车驶入隧道，黑暗降临的十二分钟里，每个人都可能是凶手。真相，藏在最不起眼的细节中。",
    cover:
      "https://readdy.ai/api/search-image?query=Suspenseful%20crime%20film%20poster%2C%20mysterious%20night%20train%20emerging%20from%20a%20dark%20tunnel%20with%20amber%20headlights%2C%20deep%20charcoal%20and%20black%20tones%2C%20tense%20atmospheric%20mood%2C%20artistic%20minimal%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-train&orientation=portrait",
    episodeCount: 1,
    updateStatus: "已上映",
    rating: 8.1,
    views: 52300000,
    tags: ["悬疑", "热映"],
  },
  {
    id: "against-light",
    title: "逆光而行",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "励志"],
    actors: ["唐澈", "沈南枝"],
    director: "何清川",
    description:
      "一名因事故失去视力的短跑运动员，在盲人长跑伙伴的陪伴下，重新站上赛道。他要跑赢的，从来不是对手，而是那个曾经想要放弃的自己。",
    cover:
      "https://readdy.ai/api/search-image?query=Inspirational%20sports%20drama%20film%20poster%2C%20silhouette%20of%20a%20runner%20sprinting%20toward%20bright%20amber%20sunlight%2C%20strong%20backlight%20against%20deep%20charcoal%20background%2C%20hopeful%20uplifting%20mood%2C%20artistic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-againstlight&orientation=portrait",
    episodeCount: 1,
    updateStatus: "已上映",
    rating: 8.6,
    views: 47800000,
    tags: ["励志", "口碑片"],
  },
  {
    id: "changan-night",
    title: "长安幻夜",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "奇幻", "动作"],
    actors: ["裴无衣", "花满楼", "燕十一"],
    director: "卢长风",
    description:
      "盛唐长安，妖气暗涌。捉妖师裴无衣与神秘女子花满楼联手，揭开了一桩牵连朝野的惊天阴谋。刀光剑影之间，一场关于人、妖与执念的奇幻之旅就此展开。",
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20ancient%20Chinese%20action%20film%20poster%2C%20shadowy%20figure%20with%20a%20glowing%20blade%20in%20misty%20ancient%20city%20alley%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20mystical%20dramatic%20mood%2C%20artistic%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-changan&orientation=portrait",
    episodeCount: 1,
    updateStatus: "已上映",
    rating: 7.9,
    views: 61200000,
    tags: ["奇幻", "热映"],
  },
  {
    id: "deep-sea-echo",
    title: "深海回声",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "冒险", "剧情"],
    actors: ["方程", "郁蓝", "林潜"],
    director: "江寒声",
    description:
      "深海科考站接收到一段来自万米海沟的神秘信号。工程师方程带队下潜，却在幽暗的海底发现了一个足以颠覆人类认知的秘密。有些回声，一旦听见，就再也无法回头。",
    cover:
      "https://readdy.ai/api/search-image?query=Sci-fi%20deep%20sea%20adventure%20film%20poster%2C%20submersible%20sinking%20into%20dark%20ocean%20abyss%20with%20faint%20amber%20lights%2C%20deep%20charcoal%20blue%20tones%2C%20mysterious%20vast%20mood%2C%20artistic%20minimal%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-deepsea&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20deep%20ocean%20abyss%20with%20a%20tiny%20submersible%20emitting%20a%20faint%20amber%20beam%20into%20the%20darkness%2C%20deep%20charcoal%20and%20teal%20tones%2C%20vast%20mysterious%20atmosphere%2C%20artistic%20cinematic%20composition%2C%20high%20detail&width=1920&height=1080&seq=juzi-banner-deepsea&orientation=landscape",
    episodeCount: 1,
    updateStatus: "已上映",
    rating: 8.2,
    views: 70500000,
    tags: ["科幻", "热映"],
  },
  {
    id: "see-you-yesterday",
    title: "明天见，昨天",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["爱情", "奇幻", "剧情"],
    actors: ["宋亦暖", "陆时", "方糖"],
    director: "简一鸣",
    description:
      "失恋后的宋亦暖发现自己可以回到过去，一次次试图挽回那段感情。可无论她如何改写，结局似乎早已注定。直到她终于明白，真正的告别，是学会与昨天和解。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20film%20poster%2C%20woman%20standing%20at%20a%20sunlit%20window%20with%20soft%20golden%20dust%20floating%20in%20the%20air%2C%20warm%20amber%20tones%20over%20deep%20charcoal%20background%2C%20melancholic%20tender%20mood%2C%20artistic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-yesterday&orientation=portrait",
    episodeCount: 1,
    updateStatus: "已上映",
    rating: 8.0,
    views: 43100000,
    tags: ["爱情", "口碑片"],
  },
  {
    id: "city-lights",
    title: "城市之光",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["犯罪", "剧情"],
    actors: ["秦川", "白晓棠", "郑铁"],
    director: "温子墨",
    description:
      "刑警秦川追查一桩连环案件，却意外牵扯出城市光鲜表象下的阴暗角落。当灯火通明的都市夜幕降临，总有人在暗处守护着微弱却坚定的光。",
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20drama%20film%20poster%2C%20lone%20figure%20standing%20on%20a%20wet%20city%20street%20amid%20amber%20streetlights%20at%20night%2C%20deep%20charcoal%20tones%2C%20gritty%20tense%20mood%2C%20artistic%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-citylights&orientation=portrait",
    episodeCount: 1,
    updateStatus: "已上映",
    rating: 8.3,
    views: 55600000,
    tags: ["犯罪", "热映"],
  },
  {
    id: "where-wind-comes",
    title: "风来的地方",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "家庭", "治愈"],
    actors: ["老周", "小满", "阿岩"],
    director: "周牧野",
    description:
      "在城市打拼失败的老周带着儿子回到故乡的山村。父子俩在田野与炊烟之间，重新学习如何相处，也重新找到了生活最本真的意义。风吹过麦浪，一切都还来得及。",
    cover:
      "https://readdy.ai/api/search-image?query=Healing%20family%20drama%20film%20poster%2C%20golden%20wheat%20field%20under%20warm%20afternoon%20sunlight%20with%20distant%20village%2C%20amber%20and%20charcoal%20tones%2C%20serene%20tender%20mood%2C%20artistic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-wind&orientation=portrait",
    episodeCount: 1,
    updateStatus: "已上映",
    rating: 8.4,
    views: 38900000,
    tags: ["治愈", "口碑片"],
  },
  {
    id: "time-concert",
    title: "时光音乐会",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "真人秀"],
    actors: ["林知夏", "周砚书", "特邀歌手"],
    director: "综艺制作团队",
    description:
      "一档以老歌新唱为主题的音乐综艺。每期邀请不同年代的歌手同台，用歌声讲述时间的故事。熟悉的旋律响起，全场都会跟着轻轻哼唱。",
    cover:
      "https://readdy.ai/api/search-image?query=Music%20variety%20show%20poster%2C%20warm%20concert%20stage%20with%20amber%20spotlights%20and%20silhouette%20of%20a%20singer%20at%20microphone%2C%20deep%20charcoal%20background%2C%20energetic%20emotional%20mood%2C%20artistic%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-concert&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20warm%20concert%20stage%20with%20amber%20spotlights%20flooding%20the%20crowd%20and%20a%20singer%20silhouette%20at%20the%20microphone%2C%20deep%20charcoal%20background%2C%20emotional%20energetic%20atmosphere%2C%20artistic%20cinematic%20composition%2C%20high%20detail&width=1920&height=1080&seq=juzi-banner-concert&orientation=landscape",
    episodeCount: 12,
    updateStatus: "更新至10期",
    rating: 8.6,
    views: 67800000,
    tags: ["音乐", "热播"],
    seasons: [{ name: "第一季", count: 12 }],
  },
  {
    id: "camping-together",
    title: "一起露营吧",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["户外", "真人秀", "治愈"],
    actors: ["何一诺", "苏牧", "柒月"],
    director: "综艺制作团队",
    description:
      "几位好友远离城市，在山野之间支起帐篷、生起篝火。没有剧本，没有台本，只有星空、晚风和一群人的真心话。一档让人想立刻出走的治愈系露营综艺。",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20camping%20variety%20show%20poster%2C%20warm%20campfire%20and%20tent%20under%20a%20starry%20night%20sky%2C%20amber%20glow%20against%20deep%20charcoal%20background%2C%20cozy%20healing%20mood%2C%20artistic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-camping&orientation=portrait",
    episodeCount: 10,
    updateStatus: "全集完结",
    rating: 8.2,
    views: 45200000,
    tags: ["治愈", "完结"],
    seasons: [{ name: "第一季", count: 10 }],
  },
  {
    id: "startup-camp",
    title: "快乐创业营",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["职场", "真人秀"],
    actors: ["傅长庚", "凌薇", "各位创业者"],
    director: "综艺制作团队",
    description:
      "一群怀揣梦想的年轻创业者聚集在一起，用一个月时间打磨从零到一的产品。有人一鸣惊人，有人铩羽而归。真实的汗水与眼泪，比任何剧本都精彩。",
    cover:
      "https://readdy.ai/api/search-image?query=Business%20reality%20show%20poster%2C%20young%20team%20collaborating%20in%20a%20warm%20modern%20office%20with%20amber%20lighting%2C%20deep%20charcoal%20tones%2C%20energetic%20motivated%20mood%2C%20artistic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-startup&orientation=portrait",
    episodeCount: 12,
    updateStatus: "更新至8期",
    rating: 7.8,
    views: 33100000,
    tags: ["职场", "热播"],
    seasons: [{ name: "第一季", count: 12 }],
  },
  {
    id: "star-kitchen",
    title: "星厨驾到",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["美食", "真人秀", "竞技"],
    actors: ["名厨联盟", "明星嘉宾"],
    director: "综艺制作团队",
    description:
      "明星与专业大厨同台竞技，用一道道菜肴讲述背后的故事。有翻车的爆笑瞬间，也有惊艳全场的招牌菜。美食的香气里，藏着最动人的人间烟火。",
    cover:
      "https://readdy.ai/api/search-image?query=Cooking%20competition%20variety%20show%20poster%2C%20chef%20plating%20an%20elegant%20dish%20in%20warm%20amber%20kitchen%20lighting%2C%20deep%20charcoal%20background%2C%20appetizing%20lively%20mood%2C%20artistic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-kitchen&orientation=portrait",
    episodeCount: 10,
    updateStatus: "更新至10期",
    rating: 8.0,
    views: 41400000,
    tags: ["美食", "热播"],
    seasons: [{ name: "第一季", count: 10 }],
  },
  {
    id: "island-trip",
    title: "环岛旅行记",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["旅行", "真人秀", "治愈"],
    actors: ["星野", "阿舟", "小满"],
    director: "综艺制作团队",
    description:
      "三位好友骑着机车环岛旅行，一路遇见陌生的人、陌生的风景和意想不到的自己。海风、日落与自由，是这趟旅程最好的注脚。",
    cover:
      "https://readdy.ai/api/search-image?query=Travel%20variety%20show%20poster%2C%20coastal%20road%20with%20motorcycle%20against%20a%20golden%20sunset%20sea%2C%20warm%20amber%20and%20charcoal%20tones%2C%20free%20wandering%20mood%2C%20artistic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-island&orientation=portrait",
    episodeCount: 8,
    updateStatus: "全集完结",
    rating: 8.1,
    views: 29800000,
    tags: ["旅行", "完结"],
    seasons: [{ name: "第一季", count: 8 }],
  },
  {
    id: "twilight-ward",
    title: "暮色病房",
    type: "teleplay",
    year: 2024,
    region: "中国大陆",
    genres: ["医疗", "剧情", "情感"],
    actors: ["顾南舟", "沈知微", "老陈"],
    director: "白露生",
    description:
      "一家城市医院的重症病房里，每天都在上演生离死别与人间冷暖。年轻医生顾南舟在这里学会的，不只是医术，还有如何温柔地面对每一个生命。",
    cover:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20poster%2C%20quiet%20hospital%20corridor%20bathed%20in%20warm%20amber%20evening%20light%2C%20deep%20charcoal%20shadows%2C%20gentle%20emotional%20mood%2C%20artistic%20minimal%20cinematic%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-ward&orientation=portrait",
    episodeCount: 34,
    updateStatus: "更新至34集",
    rating: 8.7,
    views: 92300000,
    tags: ["医疗", "热播"],
    seasons: [{ name: "第一季", count: 34 }],
  },
  {
    id: "old-town-letters",
    title: "老城来信",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "文艺", "家庭"],
    actors: ["许知秋", "老裁缝", "小夏"],
    director: "苏木",
    description:
      "一封迟到四十年的信，让年迈的老裁缝重新走上了寻找旧友的路。老城的巷弄、斑驳的墙皮与一封封泛黄的信笺，串起了一段被时光尘封的往事。",
    cover:
      "https://readdy.ai/api/search-image?query=Literary%20drama%20film%20poster%2C%20elderly%20figure%20holding%20a%20letter%20in%20a%20sunlit%20old%20town%20alley%2C%20warm%20amber%20and%20faded%20charcoal%20tones%2C%20nostalgic%20gentle%20mood%2C%20artistic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=juzi-cover-letters&orientation=portrait",
    episodeCount: 1,
    updateStatus: "已上映",
    rating: 8.5,
    views: 36700000,
    tags: ["文艺", "口碑片"],
  },
];